import { render, staticRenderFns } from "./newsCreateModal.vue?vue&type=template&id=3efd9000&"
import script from "./newsCreateModal.vue?vue&type=script&lang=ts&"
export * from "./newsCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports